import * as formerie from "./index.js";

export * from "./index.js";

type FormerieBrowserGlobal = typeof formerie;

declare global {
  var Formerie: FormerieBrowserGlobal | undefined;

  interface Window {
    Formerie?: FormerieBrowserGlobal;
  }
}

const globalScope = globalThis as typeof globalThis & {
  Formerie?: FormerieBrowserGlobal;
};

globalScope.Formerie = {
  ...(globalScope.Formerie ?? {}),
  ...formerie,
};
